export default "__VITE_ASSET__DiwZe$9H__"